import { combineEpics } from 'redux-observable';
import navigate from './navigate';

export const appEpic = combineEpics(navigate);
